import { Component, ElementRef, inject, input, OnDestroy, output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Company } from '../../../companies/models/company';

@Component({
  selector: 'app-company-autocomplete',
  templateUrl: './company-autocomplete.component.html',
  styleUrl: './company-autocomplete.component.scss',
  standalone: false
})
export class CompanyAutocompleteComponent implements OnDestroy {
  private elementRef = inject(ElementRef);
  private scrollableContainer: HTMLElement | null = null;
  private previousOverflow = '';

  companies = input<Company[]>([]);
  label = input('Company');
  requiredErrorMessage = input('You must select company.');
  isReadonly = input(false);
  readonlyValue = input<string | null>(null);
  formControl = input<FormControl | null>(null);

  get hasError(): boolean {
    const ctrl = this.formControl();
    return !!ctrl && ctrl.invalid && (ctrl.dirty || ctrl.touched);
  }

  searchTermChange = output<string>();
  companySelected = output<Company>();

  ngOnDestroy(): void {
    if (this.scrollableContainer) {
      this.scrollableContainer.style.overflow = this.previousOverflow ?? '';
      this.scrollableContainer = null;
    }
  }

  onSearchTermChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.searchTermChange.emit(target.value);
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const company = event.option.value as Company;
    this.companySelected.emit(company);
  }

  displayCompanyFn(company: Company): string {
    return company?.name ?? '';
  }

  onPanelOpened(): void {
    this.scrollableContainer = this.elementRef.nativeElement.closest('.portal-classic-content');
    if (this.scrollableContainer) {
      this.previousOverflow = this.scrollableContainer.style.overflow;
      this.scrollableContainer.style.overflow = 'hidden';
    }
  }

  onPanelClosed(): void {
    if (this.scrollableContainer) {
      this.scrollableContainer.style.overflow = this.previousOverflow ?? '';
      this.scrollableContainer = null;
      this.previousOverflow = '';
    }
  }

}
